"use client";
import React from 'react';
import MenuSidebar from '@/app/components/menuSidebar';

const Road: React.FC = () => {
  return (
    <div className='wrapper max-w-10xl mx-auto bg-white px-4 sm:px-6 lg:px-8'>
      <div className='
        max-w-7xl mx-auto p-6 bg-white shadow-md rounded-lg
        2xl:max-w-2xl
        lg:max-w-lg
        md:max-w-md
        sm:max-w-sm
        flex
        flex-col lg:flex-row gap-6
      '>
        <div className='flex-1'>
          <h1 className="text-3xl font-bold mb-6">구성도</h1>
          <div className="mb-6 text-gray-700">
            잦은 사고가 발생하는 도로를 실시간 감시하며 동시에 지능형 영상처리 기술을 이용하여 실시간 CCTV 영상을 분석 후 갓길사고/교차로사고/위험사면 사고 및 후미등 고장으로 인한 후방추돌 등 사고유발원인을 조기에 감지하고 관리자에게 통보함으로써 대형 사고가 일어나슴 것을 방지하는 시스템이다.
          </div>

          <h2 className="text-2xl font-semibold mb-4 mt-10">기능</h2>
          <ul className="list-disc list-inside mb-6 text-gray-700 space-y-2">
            <div><strong>영상 분석 / 사고 감지:</strong> 영상 실시간 분석, 주장치 1대 동시 8채널 이상 영상 분석, 갓길차량 또는 보행자, 교차로 사고, 위험사면으로부터의 낙석, 교통정체 감지</div>
            <div><strong>후미등 자동 인식 및 경보:</strong> 후미등이 고장/오염으로 인해 식별이 불가능한 대형화물차를 CCTV 영상에서 자동 추출하여 전광판을 통해 운전자에게 경고</div>
            <div><strong>단일 및 복합 사고 감지</strong></div>
          </ul>

          <h2 className="text-2xl font-semibold mb-4 mt-10">알람 / 이벤트 관리</h2>
          <ul className="list-disc list-inside mb-6 text-gray-700 space-y-2">
            <div>사고 감지 시 유고 알람</div>
            <div>이벤트 발생 알람, 팝업창 표시</div>
            <div>설정된 이벤트 시나리오대로 신속한 유고상황 대응</div>
          </ul>

          <h2 className="text-2xl font-semibold mb-4 mt-10">사고현장 위치정보 추적 기능</h2>

          <h2 className="text-2xl font-semibold mb-4 mt-10">통합관제 / 관리</h2>
          <ul className="list-disc list-inside mb-6 text-gray-700 space-y-2">
            <div><strong>다채널 영상 관제</strong></div>
            <div><strong>다양한 설정:</strong> 검지영역 설정, 사용자 등록 및 장애내용 보고</div>
          </ul>

          <h2 className="text-2xl font-semibold mb-4 mt-10">저장 / 검색 / 연계</h2>
          <ul className="list-disc list-inside mb-6 text-gray-700 space-y-2">
            <div><strong>유고영상 저장 및 검색</strong></div>
            <div><strong>유고 이벤트 로그 저장</strong></div>
            <div><strong>도로 내 영상설비와 연계 및 기타 설비와 인터페이스</strong></div>
          </ul>

          <h2 className="text-2xl font-semibold mb-4 mt-10">통계 / 보고서 작성</h2>
          <div className="mb-6 text-gray-700">
            저장된 검출 이벤트를 바탕으로 손쉽게 통계보고서 작성
          </div>
        </div>

        <div className='h-auto p-30px'>
        <MenuSidebar category="ITS" />
        </div>
      </div>
    </div>
  );
};

export default Road;
